import { render, staticRenderFns } from "./psuBzjPayForm.vue?vue&type=template&id=5df6cd6c&scoped=true"
import script from "./psuBzjPayForm.vue?vue&type=script&lang=js"
export * from "./psuBzjPayForm.vue?vue&type=script&lang=js"
import style0 from "./psuBzjPayForm.vue?vue&type=style&index=0&id=5df6cd6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df6cd6c",
  null
  
)

export default component.exports